/* eslint-disable react/no-unknown-property */
import { Vector3 } from 'three';

const PAN_FACTOR = 0.12; // fraction of camera-to-target distance moved per click
const ZOOM_FACTOR = 0.85; // <1 zooms in, 1/ZOOM_FACTOR zooms out

// Translates the camera and its target together along the camera's own local
// right/up axes — this is the same math OrbitControls uses internally for
// right-click-drag panning, reimplemented here since it doesn't expose a
// public "pan by this much" method. Scaled by distance-to-target so a click
// feels like the same-size move whether zoomed in close or far out.
const ViewportControls = ({ controlsRef }) => {
  const pan = (dx, dy) => {
    const controls = controlsRef.current;
    if (!controls) return;
    const camera = controls.object;
    const distance = camera.position.distanceTo(controls.target);
    const panScale = distance * PAN_FACTOR;

    const te = camera.matrix.elements;
    const xAxis = new Vector3(te[0], te[1], te[2]);
    const yAxis = new Vector3(te[4], te[5], te[6]);

    const offset = new Vector3()
      .addScaledVector(xAxis, dx * panScale)
      .addScaledVector(yAxis, dy * panScale);

    camera.position.add(offset);
    controls.target.add(offset);
    controls.update();
  };

  const zoom = (factor) => {
    const controls = controlsRef.current;
    if (!controls) return;
    const camera = controls.object;
    const offset = camera.position.clone().sub(controls.target).multiplyScalar(factor);
    camera.position.copy(controls.target).add(offset);
    controls.update();
  };

  const btnCls = 'flex h-7 w-7 items-center justify-center rounded-md bg-white/10 text-slate-300 transition hover:bg-white/20 hover:text-white';

  return (
    <div className="absolute top-3 right-3 z-10 flex flex-col items-center gap-1.5 rounded-xl border border-white/10 bg-black/60 p-2 backdrop-blur-sm">
      <button type="button" className={btnCls} onClick={() => pan(0, 1)} title="Move up">
        <span className="material-symbols-outlined text-[16px]">keyboard_arrow_up</span>
      </button>
      <div className="flex items-center gap-1.5">
        <button type="button" className={btnCls} onClick={() => pan(-1, 0)} title="Move left">
          <span className="material-symbols-outlined text-[16px]">keyboard_arrow_left</span>
        </button>
        <button type="button" className={btnCls} onClick={() => pan(0, -1)} title="Move down">
          <span className="material-symbols-outlined text-[16px]">keyboard_arrow_down</span>
        </button>
        <button type="button" className={btnCls} onClick={() => pan(1, 0)} title="Move right">
          <span className="material-symbols-outlined text-[16px]">keyboard_arrow_right</span>
        </button>
      </div>
      <div className="mt-0.5 flex items-center gap-1.5 border-t border-white/10 pt-1.5">
        <button type="button" className={btnCls} onClick={() => zoom(ZOOM_FACTOR)} title="Zoom in">
          <span className="material-symbols-outlined text-[16px]">add</span>
        </button>
        <button type="button" className={btnCls} onClick={() => zoom(1 / ZOOM_FACTOR)} title="Zoom out">
          <span className="material-symbols-outlined text-[16px]">remove</span>
        </button>
      </div>
    </div>
  );
};

export default ViewportControls;
